import { border } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { buttonDefault } from "../../../constants/colors";

export const selectBasicFontTheme = themed({
    variant: {
        "lodestar-light": "bodyText",
        "ursa-light": "Inter--14px--400w",
    },
});

export const optionFontTheme = themed({
    variant: {
        "lodestar-light": "bodyStrong",
        "ursa-light": "Inter--14px--400w",
    },
});

export const selectV2Theme = themed({
    padding: {
        "lodestar-light": "10px 8px",
        "ursa-light": "7px 8px",
    },
    border: {
        focusedRule: {
            "lodestar-light": "border",
            "ursa-light": "border-bottom",
        },
        focusedRadius: {
            "lodestar-light": border.radius10,
            "ursa-light": "0",
        },
        focusedInset: {
            "lodestar-light": "0px",
            "ursa-light": "1px",
        },
    },
    option: {
        backgroundColor: {
            hover: color("color--background--neutral--weakest"),
            active: color("color--background--neutral--default"),
        },
        noResults: {
            textAlign: {
                "lodestar-light": "center",
                "ursa-light": "inline-start",
            },
            fontSize: {
                "lodestar-light": "13px",
                "ursa-light": "14px",
            },
        },
        gap: {
            "lodestar-light": "0px",
            "ursa-light": "4px",
        },
        borderRadius: {
            "lodestar-light": border.radius10,
            "ursa-light": "0px",
        },
        margin: {
            virtualized: {
                "lodestar-light": "0px",
                "ursa-light": "0px",
            },
            default: {
                "lodestar-light": "0px 4px",
                "ursa-light": "0px",
            },
        },
    },
    actionButtons: {
        background: {
            hover: {
                // no semantic equivalent for buttonDefault
                "lodestar-light": buttonDefault,
                "ursa-light": color("color--background--neutral--weaker"),
            },
            active: color("color--background--neutral--default"),
        },
        buttonWrapperSize: {
            "lodestar-light": "20px",
            "ursa-light": "",
        },
        gap: {
            "lodestar-light": "0px",
            "ursa-light": "4px",
        },
        size: {
            default: {
                "lodestar-light": "32px",
                "ursa-light": "20px",
            },
            "32": {
                "lodestar-light": "24px",
                "ursa-light": "20px",
            },
            "40": {
                "lodestar-light": "32px",
                "ursa-light": "28px",
            },
        },
        borderRadius: {
            "lodestar-light": "4px",
            "ursa-light": "6px",
        },
        margin: {
            top: {
                "lodestar-light": "4px",
                "ursa-light": "6px",
            },
            right: {
                "lodestar-light": "4px",
                "ursa-light": "6px",
            },
        },
    },
    autoSizeInput: {
        minHeight: {
            default: {
                "lodestar-light": "28px",
                "ursa-light": "20px",
            },
            "32": {
                "lodestar-light": "20px",
                "ursa-light": "20px",
            },
            "40": {
                "lodestar-light": "28px",
                "ursa-light": "24px",
            },
        },
        left: {
            "lodestar-light": "6px",
            "ursa-light": "2px",
        },
    },
    chip: {
        size: {
            default: {
                "lodestar-light": "medium",
                "ursa-light": "xsmall",
            },
            "32": {
                "lodestar-light": "xsmall",
                "ursa-light": "xsmall",
            },
            "40": {
                "lodestar-light": "medium",
                "ursa-light": "small",
            },
        },
    },
    input: {
        padding: {
            left: {
                "lodestar-light": "12px",
                "ursa-light": "8px",
            },
            placeholder: {
                "lodestar-light": "40px",
                "ursa-light": "32px",
            },
        },
    },
    contentBefore: {
        width: {
            "lodestar-light": "40px",
            "ursa-light": "var(--sds--content--before--width, 32px)",
        },
        flex: {
            "lodestar-light": "0 0 40px",
            "ursa-light": "var(--sds--content--before--flex, 0 0 32px)",
        },
    },
} as const);
